import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsProvider } from "../providers/utils-provider.service";

@Pipe({standalone: true,  name: 'durationVerbose'})
export class DurationVerbosePipe implements PipeTransform {

    private _conversion: any = {
        miliseconds: { ordinal: 0, divider: 1000, unit: 'duration_ms' },
        seconds: { ordinal: 1, divider: 60, unit: 'duration_sec' },
        minutes: { ordinal: 2, divider: 60, unit: 'duration_min' },
        hours: { ordinal: 3, divider: 24, unit: 'duration_h' },
        days: { ordinal: 4, divider: 7, unit: 'duration_d' },
        weeks: { ordinal: 5, divider: 1, unit: 'duration_w' }
    };

    private _index: string[] = ['miliseconds', 'seconds', 'minutes', 'hours', 'days', 'weeks'];

    constructor(
        private _utils: UtilsProvider,
        private _translater: TranslateService
    ) { }

    public transform(str: string | number, inputUnit = 'seconds', roundTo = 'miliseconds'): string {
        if (typeof str === 'number') {
            str = '' + str;
        }

        let num: number = this.convertToMs(str, inputUnit);
        num = this.roundTo(num, roundTo);
        const parts: string[] = [];
        this._index.forEach((key: string) => {
            if (num > 0) {
                const unitNum: number = num % this._conversion[key].divider;
                if (unitNum > 0 || parts.length > 0) {
                    parts.push(unitNum + ' ' + this._translater.instant(this._conversion[key].unit));
                }

                num -= unitNum;
                num /= this._conversion[key].divider;
            }
        });

        return parts.length == 0 ? 0 + ' ' + this._translater.instant((this._conversion[inputUnit].unit)) : parts.reverse().join(' ');
    }

    private convertToMs(str: string, inputInit: string): number {
        let num: number = parseFloat(str);
        if (!num) {
            return 0;
        }

        for (let i = this._index.indexOf(inputInit) - 1; i >= 0; i--) {
            num = num * this._conversion[this._index[i]].divider;
        }

        return num;
    }

    private roundTo(num: number, unit: string): number {
        let divider: number = this._conversion[this._index[0]].divider;
        for (let i = 1; i < this._conversion[unit].ordinal; i++) {
            divider *= this._conversion[this._index[i]].divider;
            const mod: number = num % divider;
            if (mod !== 0) {
                num -= mod;
                const modDiff: number = (divider / 2) - mod;
                if (modDiff <= 0) {
                    num += divider;
                }
            }
        }

        return num;
    }
}
